module.exports = __webpack_public_path__ + "static/media/credit-card-white.784e1af7.svg";